import styled from "styled-components";
import { Link as BaseLink } from "react-router-dom";

export const Wrapper = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    & > :is(div,a):last-child{
        color: #475569;
        pointer-events: none;
        & > a{
            color: #475569;
        }
    }
`;

export const Link = styled(BaseLink)`
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    color: #475569;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 180px;
    text-decoration: none;
    &.capitalize{
        text-transform: capitalize;
    }

    transition: color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        color: var(--slate-700, #334155);
        box-shadow: 0 2px 0 0 var(--slate-400, #94A3B8);
    }
`;

export const ArrowImage = styled.img`
    width: 18px;
    height: 18px;
    margin: 0;
`;

export const CapitalizeText = styled.div`
    &.capitalize{
        text-transform: capitalize;
    }
`;
